// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4ORg_","footerContent":"Footer_footerContent__ybLti","column":"Footer_column__IylrH","text":"Footer_text__LWzGg"};